import { BranchDesignator, CodeNext, Export } from '@fusion-advantage/backcompat'
import { datestamp, timestamp } from '../util'

// the database's hardcoded Test Mode GUID: [api].[Form_Import_v002] throws
// away any import for this Encounter_GUID (status moves included), so even
// if a preview save slipped past the client-side block nothing is persisted
export const PREVIEW_ENCOUNTER_GUID = 'A836439E-B119-4CCE-ABB3-B40DB2A41622'
// the API uses the same GUID as the Training mode member
const PREVIEW_MEMBER_GUID = PREVIEW_ENCOUNTER_GUID
const PREVIEW_GENDER = 2
const PREVIEW_BIRTH_DATE = '1950-06-15'
const PREVIEW_MEMBER_NAME = 'Preview Member'
const PREVIEW_MEMBER_ID = 'PREVIEW'
const PREVIEW_CLINICIAN_NAME_DEGREE = 'Preview Clinician, NP'
export const PREVIEW_CODE_NEXT = CodeNext.InProgress

export interface PreviewBranch {
	branchGuid: string
	branchDesignator: BranchDesignator
	// the branch's live renderer; null = the built-in renderer
	rendererNumber: number|null
	minimumBundle: number|null
}

export const createPreviewExport = (preview: PreviewBranch): Export => {
	const now = timestamp()
	return {
		Form: {
			Encounter: {
				Encounter_GUID: PREVIEW_ENCOUNTER_GUID,
				EncounterCreateDT: now,
				EncounterLastUpdateDT: now,
				EncounterAppLastStatusDT: now,
				BranchGUID: preview.branchGuid,
				CodeNext: PREVIEW_CODE_NEXT,
				DateOfService: datestamp(),
				ClinicianNameDegree: PREVIEW_CLINICIAN_NAME_DEGREE,
				BranchDesignatorV2: preview.branchDesignator,
				FormRenderNbr: preview.rendererNumber,
				MinimumBundle: preview.minimumBundle,
				DisplayWarnings: true,
			},
			Member: {
				BirthDate: PREVIEW_BIRTH_DATE,
				CMSID: PREVIEW_MEMBER_ID,
				Gender: PREVIEW_GENDER,
				MemberID: PREVIEW_MEMBER_ID,
				MemberName: PREVIEW_MEMBER_NAME,
				Member_GUID: PREVIEW_MEMBER_GUID,
			},
			CancelReason: [],
			ConceptStatuses: {},
		},
	}
}
